/*#__PURE__*/ export default JSON.parse('{"key":"avantgardeCards","type":"root","items":[]}');